import React, { useState, useEffect, useRef } from "react";
import Select from 'react-select';
import {
    CButton,
    CCard,
    CCardBody,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CFormLabel,
    CFormInput,
    CSpinner,
    CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody,
} from "@coreui/react";
import CustomAgGrid from './../../components/shared/CustomAgGrid';
import GetDiagnosisData from "../../services/general/getDiagnosisData.api";
import SaveRisksData from "../../services/general/saveRisksData.api";
import DeleteDiagnosis from "../../services/general/deleteDiagnosis.api";
import DiagnosisDetails from './DiagnosisDetails';
import Pageloader from "../../components/shared/Pageloader";
import { select } from "@syncfusion/ej2-base";
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import ReasonSuggestion from "./ReasonSuggestion";
import RiskFactorDetails from "./RiskFactorDetails";
import { SaveActivity } from "./save-activity";

const RiskFactors = () => {
    const [diagnosisData, setDiagnosisData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentDiagnosisId, setCurrentDiagnosisId] = useState(null);
    const [selectedDiagnosis, setSelectedDiagnosis] = useState(null);
    const [diagnosisOptions, setDiagnosisOptions] = useState([]);
    const [keywords, setKeywords] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [deleteVisibleId, setDeleteVisibleId] = useState(null)
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [diagnosisKeywords, setDiagnosisKeywords] = useState([]);
    const [activeKey, setActiveKey] = useState(null);
    const [keywordsData, setKeywordsData] = useState([]);
    const [riskKeywords, setRiskKeywords] = useState([]);
    const [diagnosesDataList, setDiagnosesDataList] = useState([]);
    const [riskIndexUpdate,setRiskIndexUpdate] = useState(null);

    const filterRiskFactor = () => {

        const filtered = riskKeywords.filter(risk => keywords.includes(risk.riskName));
        setRiskKeywords(filtered)
    }
    useEffect(() => {
        if (riskIndexUpdate !== null) {
            console.log('update risk factors');
    
            setRiskKeywords(prev => {
                const updated = Array.isArray(prev) ? [...prev] : [];
    
                console.log(updated[riskIndexUpdate])
                if (updated[riskIndexUpdate]) {
                    updated[riskIndexUpdate] = {
                        ...updated[riskIndexUpdate],
                        riskName: keywords[riskIndexUpdate], // Update riskName
                        // keywords: [...keywords], // Update keywords array
                    };
                }
    
                return updated;
            });
    
            setRiskIndexUpdate(null); // Reset the index after updating
        } else {
            setRiskKeywords(prev => {
                const updated = Array.isArray(prev) ? [...prev] : [];
    
                keywords.forEach((riskName, index) => {
                    if (!updated[index]) {
                        updated[index] = { riskName, keywords: [] };
                    }
                });
    
                return updated;
            });
    
            if (keywords?.length <= riskKeywords?.length) {
                filterRiskFactor();
            }
        }
    }, [keywords]);
    
    const handleRiskFactorReorder = (dragIndex, dropIndex) => {
    if (
        dragIndex === dropIndex ||
        dragIndex < 0 ||
        dropIndex < 0 ||
        dragIndex >= riskKeywords.length ||
        dropIndex >= riskKeywords.length
    ) {
        return
    }

    const reorderedRiskKeywords = [...riskKeywords]

    const [movedRiskFactor] = reorderedRiskKeywords.splice(
        dragIndex,
        1
    )

    reorderedRiskKeywords.splice(
        dropIndex,
        0,
        movedRiskFactor
    )

    // Update detailed risk factor data
    setRiskKeywords(reorderedRiskKeywords)

    // Keep the Risk Factor names in exactly the same order
    setKeywords(
        reorderedRiskKeywords
            .map((item) => item?.riskName?.trim())
            .filter(Boolean)
    )

    // Clear edit index because indexes have changed
    setRiskIndexUpdate(null)
}


    const deleteDiagnosis = async (e) => {
        await SaveRisksData("DELETE", "", "", "", deleteVisibleId?.id, "");
        // Update local storage data
        // let localData = JSON.parse(localStorage.getItem(localStorageKey)) || [];
        // const updatedData = localData.filter(diagnosis => diagnosis.id !== e.id);
        // localStorage.setItem(localStorageKey, JSON.stringify(updatedData));

        // Update state data
        getData()
        setDeleteVisibleId(null)
        //setDiagnosisData(updatedData);
        SaveActivity("Deleted the Risks")

    };

    const handleEditDiagnosis = (e) => {
        setIsEditing(true);
        setCurrentDiagnosisId(e.id);
        setSelectedDiagnosis({ value: e.id, label: e.Name, keywords: e.Keywords });
        setKeywords(e.RiskFactors ? e.RiskFactors.split(",") : []);
        setModalVisible(true);
        let data = diagnosisData?.filter(item => item.id === e.id)
        setRiskKeywords(JSON.parse(data[0].RiskFactors1));
    };

    const rowClicked = (type, rowClicked) => {
        if (type === "DELETE") {
            setDeleteVisibleId(rowClicked);
        } else {
            handleEditDiagnosis(rowClicked);
        }
    };

    const buttonList = [
        { Name: 'Edit' }, { Name: 'Delete' }];

    const handleOnClick = () => {
        setIsEditing(false);
        setCurrentDiagnosisId(null);
        setSelectedDiagnosis(null);
        setKeywords([]);
        setModalVisible(true);
        setRiskKeywords([])
    };

    const saveDiagnosis = async () => {
        setIsLoading(true)
        try {
            if (!selectedDiagnosis) {
                alert("Please select a diagnosis.");
                return;
            }
            let finalKeywords = keywords.join(",");
            let riskKeywordsData = JSON.stringify(riskKeywords)
            await SaveRisksData(isEditing ? 'UPDATE' : 'INSERT', selectedDiagnosis.label, '', finalKeywords, isEditing ? currentDiagnosisId : '-1', riskKeywordsData);

            // Update local storage data
            // let localData = JSON.parse(localStorage.getItem(localStorageKey)) || [];
            // if (isEditing) {
            //     localData = localData.map(diagnosis => 
            //         diagnosis.id === currentDiagnosisId ? { ...diagnosis, Name: selectedDiagnosis.label, Risks: finalKeywords } : diagnosis
            //     );
            // } else {
            //     const newDiagnosis = {
            //         id: new Date().getTime(), // Using timestamp as a unique ID for demonstration purposes
            //         Name: selectedDiagnosis.label,
            //         Risks: finalKeywords
            //     };
            //     localData.push(newDiagnosis);
            // }
            // localStorage.setItem(localStorageKey, JSON.stringify(localData));

            // // Refresh data after saving
            // setDiagnosisData(localData);
            // updateDiagnosisOptions(localData);

            setModalVisible(false);
            setKeywords([]); // Clear keywords when the modal is closed
            setRiskKeywords([])
            getData()
            SaveActivity("Updated the Risks")

        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    };

    const getData = async () => {
        setIsPageLoading(true)
        try {
            let data;
            // let localData = localStorage.getItem(localStorageKey);
            let responseRisks = await GetDiagnosisData("Risks");
            let localData = JSON.parse(responseRisks.d)?.Data;
            let response = await GetDiagnosisData("");
            let diagnosis = JSON.parse(response.d)?.Data;
            // localStorage.setItem(localStorageKey, JSON.stringify(data));
            setDiagnosisData(localData);
            let displayDiagnosisData = localData.map((item, index) => {
                return {
                    id: item.id,
                    Name: item.Name,
                    RiskFactors: item.RiskFactors,
                }
            })
            setDiagnosesDataList(displayDiagnosisData)
            updateDiagnosisOptions(diagnosis);
        } catch (error) {
            console.log(error)
        } finally {
            setIsPageLoading(false);
        }
    };

    const updateDiagnosisOptions = (data) => {


        const options = data.map(item => ({
            value: item.id,
            label: item.Name,
            keywords: item.Keywords
        }));
        setDiagnosisOptions(options);
    };

    const toggleAccordion = (index) => {
        setActiveKey(activeKey === index ? null : index);
    };

    useEffect(() => {
        setDiagnosisKeywords([])
    }, [selectedDiagnosis])



    useEffect(() => {
        getData();
    }, []);

    console.log(riskKeywords,riskIndexUpdate)

    return (
        <>
            <div className="position-relative patient-theme-page risk-factors-theme">
                <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme">
                <CCard className="m-2 master-grid-theme__toolbar">
                    <CCardBody className="master-grid-theme__toolbar-body">
                        <CButton className="m-2 ui-action-btn ui-action-btn--primary" onClick={handleOnClick}>
                            + Add Risks
                        </CButton>
                    </CCardBody>
                </CCard>

                <CustomAgGrid className="risk-factors-theme__grid" rowClickedFn={rowClicked} callFrom="Diagnosis" options={diagnosesDataList} btnList={buttonList} />

   <CModal
    className="patient-theme-modal risk-factors-theme__diagnosis-modal"
    size="xl"
    backdrop="static"
    visible={modalVisible}
    onClose={() => {
        setModalVisible(false);
        setKeywords([]);
        setRiskKeywords([]);
    }}
>
    <CModalHeader
        onClose={() => {
            setModalVisible(false);
            setKeywords([]);
            setRiskKeywords([]);
        }}
    >
        <CModalTitle>
            {isEditing ? 'Edit Diagnosis' : 'Add Diagnosis'}
        </CModalTitle>
    </CModalHeader>

    <CModalBody style={{ padding: '1rem' }}>
        {modalVisible && (
            <div
                className="d-flex gap-3 w-100"
                style={{
                    
                    alignItems: 'stretch',
                }}
            >

                {/* LEFT 50% */}
                <div
                    style={{
                        width: '50%',
                        flex: '0 0 calc(50% - 0.5rem)',
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {/* Diagnosis */}
                    <div className="mb-3">
                        <CFormLabel>Select Diagnosis</CFormLabel>

                        <Select
                            className="basic-single-select"
                            classNamePrefix="select"
                            value={selectedDiagnosis}
                            onChange={setSelectedDiagnosis}
                            options={diagnosisOptions}
                            isDisabled={isEditing}
                        />
                    </div>

                    {/* Risk Factors Accordion */}
                    {keywords.length > 0 && (
                        <div
                            className="rounded risk-factors-theme__modal-accordion-shell"
                            style={{
                                flex: 1,
                                minHeight: '10px',
                                 overflowY: 'scroll',
                                overflowX: 'hidden',
                            }}
                        >
                            <CAccordion
                                activeItemKey={activeKey}
                                className="accordion-custom risk-factors-theme__modal-accordion"
                            >
                                {riskKeywords?.map((riskFactor, index) => (
                                    <CAccordionItem
                                        key={index}
                                        itemKey={index}
                                        className="border-0 mb-3 risk-factors-theme__modal-accordion-item"
                                    >
                                        <CAccordionHeader
                                            onClick={() =>
                                                toggleAccordion(index)
                                            }
                                            className="risk-factors-theme__modal-accordion-header"
                                        >
                                            {riskFactor.riskName}
                                        </CAccordionHeader>

                                        <CAccordionBody>
                                            <div className="risk-factors-theme__modal-accordion-body">
                                                <DiagnosisDetails
                                                    label="Keywords"
                                                    keywords={riskFactor.keywords}
                                                    setKeywords={(newKeywords) => {
                                                        setRiskKeywords((prev) => {
                                                            const updated = [...prev];

                                                            updated[index] = {
                                                                ...updated[index],
                                                                keywords: newKeywords,
                                                            };

                                                            return updated;
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </CAccordionBody>
                                    </CAccordionItem>
                                ))}
                            </CAccordion>
                        </div>
                    )}
                </div>

                {/* RIGHT 50% */}
                <div
                    style={{
                        width: '50%',
                        flex: '0 0 calc(50% - 0.5rem)',
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            minHeight: 0,
                        }}
                    >
                        <RiskFactorDetails
                            riskIndexUpdate={riskIndexUpdate}
                            setRiskIndexUpdate={setRiskIndexUpdate}
                            getData={getData}
                            label="Risk Factors"
                            className="h-100"
                            keywords={keywords}
                            setKeywords={setKeywords}
                            onReorder={handleRiskFactorReorder}
                        />
                    </div>
                </div>

            </div>
        )}
    </CModalBody>

    <CModalFooter>
        <CButton
            color="secondary"
            className="ui-action-btn ui-action-btn--secondary"
            onClick={() => {
                setModalVisible(false);
                setKeywords([]);
                setRiskKeywords([]);
            }}
        >
            Close
        </CButton>

        <CButton
            className="ui-action-btn ui-action-btn--primary"
            onClick={saveDiagnosis}
        >
            {isLoading ? (
                <>
                    <CSpinner
                        component="span"
                        size="sm"
                        variant="grow"
                        aria-hidden="true"
                    />
                    Loading...
                </>
            ) : (
                isEditing ? 'Update' : 'Save'
            )}
        </CButton>
    </CModalFooter>
</CModal>

                {/* delete modal */}
                <CModal
                    className="patient-theme-modal"
                    visible={deleteVisibleId}
                >
                    <CModalHeader>
                        <CModalTitle>Warning</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
                    </CModalBody>
                    <hr className="p-0 m-0" />
                    <CModalFooter className="p-3 m-0">
                        <CButton
                            color="secondary"
                            onClick={() => {
                                setDeleteVisibleId(null)
                            }}
                            className="ui-action-btn ui-action-btn--secondary">Close</CButton>
                        <CButton onClick={deleteDiagnosis} className="ui-action-btn ui-action-btn--delete">Delete</CButton>
                    </CModalFooter>
                </CModal>
                <Pageloader isLoading={isPageLoading} />
                </div>
            </div>
        </>
    );
};

export default RiskFactors;
